// All comments are in English.
import { useQuery } from "@tanstack/react-query";
import {
  getSalesIntelligenceSummary,
  type SalesIntelligenceResponse,
} from "../api/salesIntelligence";

export function useSalesIntelligence(
  startMonth: string,
  endMonth: string,
  companyId?: number,
  salespersonName?: string
) {
  return useQuery<SalesIntelligenceResponse>({
    queryKey: [
      "sales-intelligence",
      startMonth,
      endMonth,
      companyId ?? "",
      salespersonName ?? "",
    ],
    queryFn: () =>
      getSalesIntelligenceSummary({
        startMonth,
        endMonth,
        companyId,
        salespersonName,
      }),
    enabled: !!startMonth && !!endMonth,
    refetchOnWindowFocus: false,
  });
}
